import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Container, Card, Alert, Spinner } from "react-bootstrap";
import { authFetch } from "../utils/authFetch";
import { toast } from "react-toastify";
import { RecipeForm } from "./Form";
import { recipeCopyDraft } from './copyRecipe';

export default function RecipeCreate() {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [params] = useSearchParams();
  const sourceId = params.get('copy_from');
  const [copy, setCopy] = useState(null);
  const [loading, setLoading] = useState(!!sourceId);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    setCopy(null); setError(''); setLoading(!!sourceId);
    if (!sourceId) return () => { active = false; };
    if (!/^[1-9]\d*$/.test(sourceId) || !Number.isSafeInteger(Number(sourceId))) {
      setError('Rețeta sursă este invalidă.'); setLoading(false);
      return () => { active = false; };
    }
    authFetch(`/bxreteta/${sourceId}`).then(source => {
      if (active) setCopy(recipeCopyDraft(source));
    }).catch(e => { if (active) setError(`Rețeta nu a putut fi copiată: ${e.message || e}`); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [sourceId]);

  const handleSubmit = async (payload) => {
    setBusy(true);
    try {
      const created = await authFetch("/bxreteta/", {
        method: "POST",
        body: JSON.stringify(payload),
      });
      const id = created?.id;
      toast.success("Rețeta a fost salvată cu succes!");
      if (id) {
        navigate(`/retete/${id}`);
      } else {
        navigate("/retete");
      }
    } catch (e) {
      toast.error(`Eroare la salvare: ${e?.message || e}`);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Container className="py-3">
      <Card className="shadow-sm">
        <Card.Header className="bg-success text-white">
          <h4 className="mb-0">{sourceId ? 'Copiază rețeta' : 'Rețetă Nouă (BOM)'}</h4>
        </Card.Header>
        <Card.Body>
          {loading ? <Spinner animation="border" /> : error ? <Alert variant="danger">{error}</Alert> : <>
            {sourceId && <Alert variant="info">Copie nesalvată, cu toate ingredientele. Poți schimba produsul și cantitățile. Copia este inițial inactivă; rețeta originală rămâne păstrată.</Alert>}
            <RecipeForm key={sourceId || 'new'} initialDoc={copy} copyMode={!!sourceId} onSubmit={handleSubmit} busy={busy} />
          </>}
        </Card.Body>
      </Card>
    </Container>
  );
}
